import { Chip } from '@mui/material'
import EntityListTemplate from '../../templates/EntityListTemplate'

const RolesPage = () => {
  const columns = [
    {
      field: 'name',
      headerName: 'Name',
      type: 'string',
      width: 200,
      flex: 1,
    },
    {
      field: 'description',
      headerName: 'Description',
      type: 'string',
      width: 300,
      flex: 1,
      filterable: false,
    },
    {
      field: 'isSystem',
      headerName: 'Role type',
      type: 'boolean',
      width: 150,
      renderCell: (params) =>
        params.value ? (
          <Chip label="System" color="primary" size="small" />
        ) : (
          ''
        ),
    },
  ]

  return (
    <EntityListTemplate
      entityName="roles"
      columns={columns}
      title="Roles"
      defaultSort={[{ field: 'name', sort: 'asc' }]}
      defaultFilters={{ items: [] }}
    />
  )
}

export default RolesPage
